export interface NavItem {
  id: string;
  label: string;
  icon: string;
  path: string;
  roles: string[];
}

export interface NavSection {
  title: string;
  items: NavItem[];
}

export const navigationSections: NavSection[] = [
  {
    title: "首頁",
    items: [
      {
        id: "home",
        label: "首頁",
        icon: "ri-home-4-line",
        path: "/",
        roles: ["admin", "manager", "employee", "trial"],
      },
    ],
  },
  {
    title: "工作中心",
    items: [
      {
        id: "manager-center",
        label: "主管中心",
        icon: "ri-shield-user-line",
        path: "/manager-center",
        roles: ["admin", "manager"],
      },
      {
        id: "customer-service",
        label: "客服中心",
        icon: "ri-customer-service-2-line",
        path: "/customer-service",
        roles: ["admin", "manager", "employee"],
      },
      {
        id: "knowledge-base",
        label: "知識中心",
        icon: "ri-book-open-line",
        path: "/knowledge-base",
        roles: ["admin", "manager", "employee"],
      },
      {
        id: "department-chat",
        label: "部門通訊",
        icon: "ri-building-line",
        path: "/department-chat",
        roles: ["admin", "manager", "employee"],
      },
      {
        id: "notifications",
        label: "通知中心",
        icon: "ri-notification-3-line",
        path: "/notifications",
        roles: ["admin", "manager", "employee", "trial"],
      },
    ],
  },
  {
    title: "營運管理",
    items: [
      {
        id: "products",
        label: "商品管理",
        icon: "ri-goblet-fill",
        path: "/products",
        roles: ["admin", "manager", "employee"],
      },
      {
        id: "shipping",
        label: "貨運追蹤",
        icon: "ri-truck-line",
        path: "/shipping",
        roles: ["admin", "manager", "employee"],
      },
      {
        id: "accounting",
        label: "帳務管理",
        icon: "ri-bill-line",
        path: "/accounting",
        roles: ["admin", "manager", "employee"],
      },
    ],
  },
  {
    title: "系統管理",
    items: [
      {
        id: "employees",
        label: "員工管理",
        icon: "ri-team-line",
        path: "/employees",
        roles: ["admin"],
      },
      {
        id: "salary",
        label: "薪資管理",
        icon: "ri-coins-line",
        path: "/salary",
        roles: ["admin"],
      },
      {
        id: "rbac",
        label: "權限設定",
        icon: "ri-key-2-line",
        path: "/rbac",
        roles: ["admin"],
      },
      {
        id: "system-settings",
        label: "系統設定",
        icon: "ri-settings-3-line",
        path: "/system-settings",
        roles: ["admin"],
      },
      {
        id: "operation-log",
        label: "操作紀錄",
        icon: "ri-file-list-line",
        path: "/operation-log",
        roles: ["admin", "manager"],
      },
    ],
  },
  {
    title: "個人中心",
    items: [
      {
        id: "profile",
        label: "個人中心",
        icon: "ri-user-settings-line",
        path: "/profile",
        roles: ["admin", "manager", "employee", "trial"],
      },
      {
        id: "clock-in-record",
        label: "打卡紀錄",
        icon: "ri-time-line",
        path: "/clock-in-record",
        roles: ["admin", "manager", "employee", "trial"],
      },
      {
        id: "my-applications",
        label: "我的申請",
        icon: "ri-draft-line",
        path: "/my-applications",
        roles: ["admin", "manager", "employee", "trial"],
      },
    ],
  },
];

export function getPageKeyFromPath(path: string): string | null {
  for (const section of navigationSections) {
    for (const item of section.items) {
      if (item.path === path) return item.id;
      if (path.startsWith(item.path) && item.path !== "/") return item.id;
    }
  }
  return null;
}